"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMercureSubscription;

var _react = require("react");

var _reactAdmin = require("react-admin");

var _reactRedux = require("react-redux");

function useMercureSubscription(resource, idOrIds) {
  const dataProvider = (0, _reactAdmin.useDataProvider)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const hasShownNoSubscribeWarning = (0, _react.useRef)(false);
  (0, _react.useEffect)(() => {
    const ids = Array.isArray(idOrIds) ? idOrIds : [idOrIds];

    if (!hasShownNoSubscribeWarning.current && (dataProvider.subscribe === undefined || dataProvider.unsubscribe === undefined)) {
      console.warn('subscribe and/or unsubscribe methods were not set in the data provider, Mercure realtime update functionalities will not work. Please use a compatible data provider.');
      hasShownNoSubscribeWarning.current = true;
      return;
    }

    dataProvider.subscribe(ids, document => {
      dispatch({
        type: _reactAdmin.CRUD_GET_ONE_SUCCESS,
        payload: {
          data: document
        },
        meta: {
          resource,
          fetchResponse: _reactAdmin.GET_ONE,
          fetchStatus: _reactAdmin.FETCH_END
        }
      });
    });
    return () => {
      dataProvider.unsubscribe(resource, ids);
    };
  }, [idOrIds, resource, dataProvider, dispatch]);
}